import createIcon from '../../createIcon';

/**
 * @component @name DevicesFold
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNC4wMDAwM0gxN0MxNyAyLjU3MDAzIDE1LjUzIDEuNjAwMDMgMTQuMjEgMi4xNjAwM0wxMS4yMSAzLjQ1MDAzQzEwLjQ4IDMuNzYwMDMgMTAgNC40OTAwMyAxMCA1LjI5MDAzVjIwQzEwIDIxLjEgMTAuOSAyMiAxMiAyMkgyMEMyMS4xIDIyIDIyIDIxLjEgMjIgMjBWNi4wMDAwM0MyMiA0LjkwMDAzIDIxLjEgNC4wMDAwMyAyMCA0LjAwMDAzWk0yMCAyMEgxNC42N0wxNS43OSAxOS41MkMxNi41MiAxOS4yIDE3IDE4LjQ4IDE3IDE3LjY4VjYuMDAwMDNIMjBWMjBaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNCA0LjAwMDAzSDJWNi4wMDAwM0g0VjQuMDAwMDNaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNCAyMEgyVjIySDRWMjBaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNCAxNkgyVjE4SDRWMTZaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNCAxMkgyVjE0SDRWMTJaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNCA4LjAwMDAzSDJWMTBINFY4LjAwMDAzWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTggNC4wMDAwM0g2VjYuMDAwMDNIOFY0LjAwMDAzWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTggMjBINlYyMkg4VjIwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DevicesFold = createIcon('DevicesFold', [
  [
    'path',
    {
      d: 'M20 4.00003H17C17 2.57003 15.53 1.60003 14.21 2.16003L11.21 3.45003C10.48 3.76003 10 4.49003 10 5.29003V20C10 21.1 10.9 22 12 22H20C21.1 22 22 21.1 22 20V6.00003C22 4.90003 21.1 4.00003 20 4.00003ZM20 20H14.67L15.79 19.52C16.52 19.2 17 18.48 17 17.68V6.00003H20V20Z',
      key: '1gcels',
    },
  ],
  ['path', { d: 'M4 4.00003H2V6.00003H4V4.00003Z', key: 'sng2iy' }],
  ['path', { d: 'M4 20H2V22H4V20Z', key: 'ew17fl' }],
  ['path', { d: 'M4 16H2V18H4V16Z', key: '1n62lr' }],
  ['path', { d: 'M4 12H2V14H4V12Z', key: '1in5li' }],
  ['path', { d: 'M4 8.00003H2V10H4V8.00003Z', key: 'iw9tpc' }],
  ['path', { d: 'M8 4.00003H6V6.00003H8V4.00003Z', key: 'lnxtn2' }],
  ['path', { d: 'M8 20H6V22H8V20Z', key: '16k2or' }],
]);

export default DevicesFold;
